/**
 * Public footer. Deliberately minimal — copyright + nav anchors + lang
 * switcher. Adds an inline pulse-dot to remind visitors the system is
 * live, mirroring the same pattern used in the authed app.
 */
import { useTranslation } from 'react-i18next'
import { LanguageSwitcher } from '@/components/ui/LanguageSwitcher'

export function PublicFooter() {
  const { t } = useTranslation(['common', 'landing'])
  const year = new Date().getFullYear()
  return (
    <footer className="border-t border-line bg-ink">
      <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row gap-4 items-center text-xs text-textFaint font-mono">
        <div className="flex items-center">
          <span className="dot mr-2" style={{ background: 'var(--pulse)' }} />
          {t('common:status.operational')}
        </div>

        <nav className="flex items-center gap-5 sm:ml-6">
          <a href="#features"     className="hover:text-textDim transition-colors">
            {t('landing:nav.features')}
          </a>
          <a href="#how-it-works" className="hover:text-textDim transition-colors">
            {t('landing:nav.how_it_works')}
          </a>
          <a href="#faq"          className="hover:text-textDim transition-colors">
            {t('landing:nav.faq')}
          </a>
        </nav>

        <div className="sm:ml-auto flex items-center gap-4">
          <LanguageSwitcher variant="inline" />
          <span>{t('common:footer.copyright')} · {year}</span>
        </div>
      </div>
    </footer>
  )
}
